import { EventBus } from '@primeuix/utils/eventbus';

var ToastEventBus = EventBus();

export { ToastEventBus as default };
//# sourceMappingURL=index.mjs.map
